import React, { useState } from "react";
import Tier1Panel from "../components/Tier1Panel";
import ResourceCatalogPanel from "../components/ResourceCatalogPanel";
import BuildingTypesPanel from "../components/BuildingTypesPanel";
import StructureLibraryPanel from "../components/StructureLibraryPanel";

const TABS = [
  { id: "resources", label: "რესურსები / Resources" },
  { id: "tier0",     label: "Tier 0" },
  { id: "tier1",     label: "Tier 1" },
  { id: "buildingTypes", label: "შენობის ტიპები" },
  { id: "structureLibrary", label: "სტრუქტურის ბიბლიოთეკა" },
];

export default function BasesManager({ onBack, token, isSuperuser = false, databaseGrants, initialTab, initialKind }) {
  const { catalogIds = [], resourceKinds = [] } = databaseGrants || {};
  const [activeTab, setActiveTab] = useState(initialTab || "resources");

  return (
    <div
      className="taskpane-root taskpane-root--projects taskpane-root--bases"
      data-no-translate="true"
    >
      <button className="link" onClick={onBack}>← უკან</button>

      <h1>მონაცემთა ბაზები</h1>

      <div style={{ display: "flex", gap: 0, marginBottom: 12, borderBottom: "1px solid rgba(148, 163, 184, 0.35)" }}>
        {TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            style={{
              padding: "8px 14px", fontSize: 12, border: "none", cursor: "pointer",
              borderBottom: activeTab === tab.id ? "3px solid #06b6d4" : "3px solid transparent",
              background: activeTab === tab.id ? "rgba(6, 182, 212, 0.16)" : "transparent",
              fontWeight: activeTab === tab.id ? "bold" : "normal",
              color: activeTab === tab.id ? "#7dd3fc" : "#cbd5e1",
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "resources" && (
        <ResourceCatalogPanel token={token} isSuperuser={isSuperuser} editableKinds={resourceKinds} initialKind={initialKind} />
      )}
      {activeTab === "tier0" && (
        <Tier1Panel token={token} isSuperuser={isSuperuser} editableCatalogIds={catalogIds} tier={0} />
      )}
      {activeTab === "buildingTypes" && <BuildingTypesPanel token={token} isSuperuser={isSuperuser} />}
      {activeTab === "structureLibrary" && <StructureLibraryPanel token={token} isSuperuser={isSuperuser} />}
      {activeTab === "tier1" && (
        <Tier1Panel token={token} isSuperuser={isSuperuser} editableCatalogIds={catalogIds} tier={1} />
      )}
    </div>
  );
}
